<div
  class="video-player-wrapper"
  [class.video-player-wrapper--hero]="isShownAsHero"
  [style.height]="calculatedHeightString"
  #videoPlayerWrapper
>
  <video
    class="video-player"
    controls
    [src]="videoSrc"
    [style.height]="isPlaying ? calculatedHeightString : pauseHeightString"
    (ended)="isPlaying = false"
    (play)="isPlaying = true"
    disablePictureInPicture
    controlslist="nodownload noplaybackrate"
    #videoPlayer
  ></video>
  <div
    *ngIf="!isPlaying"
    class="play-button-overlay"
    (click)="toggleVideoPlay($event)"
  >
    <markant-icon icon="m_play"></markant-icon>
  </div>
</div>
